import React from 'react';
import { Link } from 'gatsby-plugin-react-i18next';
import { gsap } from 'gsap';
import { useLocomotiveScroll } from 'react-locomotive-scroll';
import Logo from '../../../svg/Logo.svg';
import {
  MainNavigation,
  Languages,
  Currencies,
  SubNavigation,
  Burger,
} from './index';

const Header = ({ dataSubNav }) => {
  const dataMainNav = [
    { title_ua: 'Головна', title_ru: 'Главная', link: '/', marker: 'link' },
    {
      title_ua: 'Ціни',
      title_ru: 'Цены',
      link: '/anglijskij-yazyk/',
      marker: 'link',
      // marker: 'services',
    },
    { title_ua: 'Про нас', title_ru: 'О нас', link: '/about/', marker: 'link' },
    { title_ua: 'Блог', title_ru: 'Блог', link: '/blog/', marker: 'link' },
    { title_ua: 'Контакти', title_ru: 'Контакты', marker: 'contacts' },
  ];

  const dataContacts = {
    phone: '+38 (096) 275 76 98',
  };
  const telLink = dataContacts.phone.replace(/[- ()]/g, '');

  const [show, setShow] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [activeHeader, setActiveHeader] = React.useState(false);

  const { scroll } = useLocomotiveScroll();

  function showMenu() {
    setOpen(!open);
    scroll.stop();
    if (show === true) {
      setShow(false);
    }
  }

  function closeMenu() {
    setOpen(false);
    setShow(false);
    scroll.start();
  }

  function showSubMenu() {
    setShow(!show);
    if (show === false) {
      scroll.stop();
    } else {
      scroll.start();
    }
  }

  function closeSubMenu() {
    setShow(false);
    scroll.start();
  }

  const [tl] = React.useState(gsap.timeline({ paused: false }));
  let headerEl = React.useRef(null);
  let headerLineEl = React.useRef(null);

  React.useEffect(() => {
    tl.to(headerEl, {
      y: 0,
      opacity: 1,
      duration: 0.8,
      delay: 3,
    }).to(headerLineEl, {
      opacity: 1,
      duration: 0.8,
    });
    if (scroll) {
      scroll.on('scroll', (func) => {
        var scroll_pos = 0;
        scroll_pos = scroll.scroll.instance.scroll.y;

        if (scroll_pos > 100) {
          setActiveHeader(true);
        } else {
          setActiveHeader(false);
        }
      });
    }
  }, [scroll, tl]);

  return (
    <>
      <header
        className={
          activeHeader
            ? 'header-main__wrapper is-scroll'
            : 'header-main__wrapper'
        }
      >
        <div className="page-wrapper">
          <div
            className={activeHeader ? 'header is-scroll' : 'header'}
            ref={(e) => (headerEl = e)}
          >
            <div className="header-line" ref={(e) => (headerLineEl = e)}></div>
            <div
              className={
                open
                  ? 'header-menu__wrapper-overflow is-open'
                  : 'header-menu__wrapper-overflow'
              }
              style={{ top: activeHeader ? '80px' : ' ' }}
            >
              <div className="header-menu__wrapper">
                <Link to="/" className="header-logo__link header-logo__link-xl">
                  <Logo className="header-logo" />
                </Link>
                <MainNavigation
                  showSubMenu={showSubMenu}
                  dataMainNav={dataMainNav}
                  open={open}
                  closeMenu={closeMenu}
                />

                <a
                  href={'tel:' + telLink}
                  className={open ? 'header-phone is-open' : 'header-phone'}
                >
                  <span className="header-phone__overflow">
                    <span className="header-phone__title">
                      {dataContacts.phone}
                    </span>
                  </span>
                </a>
                <div className="header-menu__info">
                  <div className="header-selects">
                    <Languages
                      closeMenu={closeMenu}
                      open={open}
                      activeHeader={activeHeader}
                    />
                    <span className="header-selects__separator"></span>
                    <Currencies open={open} activeHeader={activeHeader} />
                  </div>
                </div>
              </div>
            </div>

            <Link to="/" className="header-logo__link header-logo__link-md">
              <Logo className="header-logo" />
            </Link>

            <Burger showMenu={showMenu} open={open} />
            <div className="header-background__md"></div>
          </div>
        </div>
      </header>
      <SubNavigation
        dataSubNav={dataSubNav}
        show={show}
        closeSubMenu={closeSubMenu}
        activeHeader={activeHeader}
      />
      <div
        className={
          show
            ? 'page-overlay is-show'
            : open
            ? 'page-overlay is-open'
            : 'page-overlay'
        }
        role="presentation"
        onClick={closeSubMenu}
      ></div>
    </>
  );
};

export default Header;
